export default "__VITE_ASSET__4wOiK09C__"